// const folderRoles = (await import("../server/roles/roles.constant.js")).folderRoles;

import _ from "lodash";
const FOLDER_UPLOAD = {
  id: 1,
  description: "FOLDER_UPLOAD",
  type: "RESOURCE_TYPE_FOLDER",
  status: "ACTIVE",
};
const FOLDER_DOWNLOAD = {
  id: 2,
  description: "FOLDER_DOWNLOAD",
  type: "RESOURCE_TYPE_FOLDER",
  status: "ACTIVE",
};
const FOLDER_COMMENT = {
  id: 3,
  description: "FOLDER_COMMENT",
  type: "RESOURCE_TYPE_FOLDER",
  status: "ACTIVE",
};
const FOLDER_SHARE = {
  id: 4,
  description: "FOLDER_SHARE",
  type: "RESOURCE_TYPE_FOLDER",
  status: "ACTIVE",
};
const FOLDER_STATUS_CHANGE = {
  id: 5,
  description: "FOLDER_STATUS_CHANGE",
  type: "RESOURCE_TYPE_FOLDER",
  status: "ACTIVE",
};
const FOLDER_RENAME = {
  id: 6,
  description: "FOLDER_RENAME",
  type: "RESOURCE_TYPE_FOLDER",
  status: "ACTIVE",
};
const FOLDER_DELETE = {
  id: 7,
  description: "FOLDER_DELETE",
  type: "RESOURCE_TYPE_FOLDER",
  status: "ACTIVE",
};

function folderRoles() {
  return {
    FOLDER_ADMIN: {
      id: 1,
      description: "Can edit, change permissions and transmit to other spaces",
      frontendName: "Full Access",
      code: "FULL_ACCESS",
      type: "RESOURCE_TYPE_FOLDER",
      permissions: [
        FOLDER_UPLOAD.description,
        FOLDER_STATUS_CHANGE.description,
        FOLDER_DOWNLOAD.description,
        FOLDER_COMMENT.description,
        FOLDER_SHARE.description,
        FOLDER_RENAME.description,
        FOLDER_DELETE.description,
      ],
      permissionIds: [
        FOLDER_UPLOAD.id,
        FOLDER_STATUS_CHANGE.id,
        FOLDER_DOWNLOAD.id,
        FOLDER_COMMENT.id,
        FOLDER_SHARE.id,
        FOLDER_RENAME.id,
        FOLDER_DELETE.id,
      ],
    },
    FOLDER_EDITOR: {
      id: 2,
      description: "Can create, upload, download & modify",
      frontendName: "Can Edit",
      code: "CAN_EDIT",
      type: "RESOURCE_TYPE_FOLDER",
      permissions: [
        FOLDER_UPLOAD.description,
        FOLDER_STATUS_CHANGE.description,
        FOLDER_DOWNLOAD.description,
        FOLDER_COMMENT.description,
        FOLDER_RENAME.description,
        FOLDER_DELETE.description,
      ],
      permissionIds: [
        FOLDER_UPLOAD.id,
        FOLDER_STATUS_CHANGE.id,
        FOLDER_DOWNLOAD.id,
        FOLDER_COMMENT.id,
        FOLDER_RENAME.id,
        FOLDER_DELETE.id,
      ],
    },
    FOLDER_DOWNLOADER: {
      id: 4,
      description: "Can download & view",
      frontendName: "Can Download",
      code: "CAN_DOWNLOAD",
      type: "RESOURCE_TYPE_FOLDER",
      permissions: [FOLDER_DOWNLOAD.description, FOLDER_COMMENT.description],
      permissionIds: [FOLDER_DOWNLOAD.id, FOLDER_COMMENT.id],
    },
    FOLDER_VIEWER: {
      id: 6,
      description: "Cannot edit, download or change permissions",
      frontendName: "Can View",
      code: "CAN_VIEW",
      type: "RESOURCE_TYPE_FOLDER",
      permissions: [],
      permissionIds: [],
    },
    FOLDER_NO_ACCESS: {
      id: 7,
      description: "Cannot view, edit, download or change permissions",
      frontendName: "No access",
      code: "NO_ACCESS",
      type: "RESOURCE_TYPE_FOLDER",
      permissions: [],
      permissionIds: [],
    },
  };
}

export const getPermissionConstants = () => {
  const permissions = folderRoles();
  const obj: any = {};

  Object.values(permissions).forEach((role) => {
    obj[role.code] = role.id;
  });

  return obj;
};

export const MAX_FILE_UPLOAD_SIZE = 10 * 1024 * 1024 * 1024; // 10 GB
export const RESOURCE_TYPE_PROJECT = "RESOURCE_TYPE_PROJECT";
export const RESOURCE_TYPE_PORTAL = "RESOURCE_TYPE_PORTAL";
export const RESOURCE_TYPE_TRANSMITTAL = "RESOURCE_TYPE_TRANSMITTAL";
export const RESOURCE_TYPE_SPACE = "RESOURCE_TYPE_SPACE";

export const getPermissions = (t?: any) => {
  if (!t) {
    t = (args: string) => args;
  }
  return {
    USERS_ADD_TO_PROJECT: {
      description: t("Add users to current project"),
      id: 0,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    USERS_REMOVE_FROM_PROJECT: {
      description: t("Remove users from a project"),
      id: 1,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    USERS_ADD_TO_SPACE: {
      description: t("Add User to a space"),
      id: 2,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    USERS_REMOVE_FROM_SPACE: {
      description: t("Remove User from a Space"),
      id: 3,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    USERS_VIEW_IN_PROJECT: {
      description: t("View Project Users"),
      id: 4,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    EDIT_PROJECT_INFO: {
      description: t("Edit project information"),
      id: 5,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    SPACES_ADD_TO_PROJECT: {
      description: t("Add project spaces"),
      id: 6,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    SPACES_DELETE_FROM_PROJECT: {
      description: t("Delete project spaces"),
      id: 7,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    SPACES_EDIT: {
      description: t("Edit Project spaces"),
      id: 8,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    SPACES_VIEW_IN_PROJECT: {
      description: t("View Project Spaces"),
      id: 9,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    TRANSMITTAL_CREATE: {
      description: t("Create Transmittal"),
      id: 10,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    FOLDER_ROOT_PERMISSION_CHANGE: {
      description: t("Change Root folder permissions of user"),
      id: 11,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    ROLES_VIEW_IN_PROJECT: {
      description: t("View Project Roles"),
      id: 12,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    ROLES_ADD_TO_PROJECT: {
      description: t("Add Project Roles"),
      id: 13,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    ROLES_EDIT_IN_PROJECT: {
      description: t("Edit Project Roles"),
      id: 14,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    ROLES_CHANGE_OF_USER_IN_PROJECT: {
      description: t("Change Project role of a user"),
      id: 15,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    ROLES_DELETE_IN_PROJECT: {
      description: t("Delete Project Roles"),
      id: 16,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    CONFIGURATION_SETTINGS_VIEW: {
      description: t("View Configuration Settings"),
      id: 17,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    CONFIGURATION_SETTINGS_MODIFY: {
      description: t("Modify Configuration Settings"),
      id: 18,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    SPACE_CHANGE_SPACE_INFORMATION: {
      description: t("Change Space Information"),
      id: 19,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_ADD_USERS_TO_SPACE: {
      description: t("Add Users to Space"),
      id: 20,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_REMOVE_USERS_FROM_SPACE: {
      description: t("Remove users from space"),
      id: 21,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_ADD_COMPANIES_TO_SPACE: {
      description: t("Add companies to space"),
      id: 22,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_REMOVE_COMPANIES_FROM_SPACE: {
      description: t("Remove companies from space"),
      id: 23,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_CREATE_FOLDERS_SUBFOLDERS: {
      description: t("Create folders and sub folders"),
      id: 24,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_UPLOAD_FILES: {
      description: t("Upload files"),
      id: 25,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_DOWNLOAD_FILES_FOLDERS: {
      description: t("Download Files/Folders"),
      id: 26,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_CREATE_FILE_PLACEHOLDERS: {
      description: t("Create File Spaceholders"),
      id: 27,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_COMMENT_ON_FILE: {
      description: t("Comment on a file"),
      id: 28,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_DELETE_OWN_COMMENTS: {
      description: t("Delete own comments"),
      id: 29,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_DELETE_OTHER_COMMENTS: {
      description: t("Delete other comments"),
      id: 30,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_ASSIGN_SHARING_TO_FILE_FOLDER: {
      description: t("Assign sharing process to files/folder"),
      id: 31,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_UNASSIGN_SHARING_TO_FILE_FOLDER: {
      description: t("Unassign sharing process to files/folder"),
      id: 32,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    PROJECT_ADD_TO_PORTAL: {
      description: t("Add projects to the portal"),
      id: 33,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    PROJECT_LIST_VIEW_IN_PORTAL: {
      description: t("View all Projects List of Portal"),
      id: 34,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    PROJECT_ARCHIVE_OF_PORTAL: {
      description: t("Archive projects of the portal"),
      id: 35,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    // PROJECT_INFORMATION_EDIT: {
    //   description: t("Edit Project Information"),
    //   id: 36,
    //   status: "ACTIVE",
    //   type: RESOURCE_TYPE_PORTAL,
    // },
    VIEW_ACCEPTED_COMPANIES: {
      description: t("View Accepted Companies"),
      id: 37,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_INVITED_COMPANIES: {
      description: t("View Invited Companies"),
      id: 38,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    PORTAL_REMOVE_COMPANIES: {
      description: t("Remove company from the portal"),
      id: 39,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    PORTAL_ADD_COMPANIES: {
      description: t("Add company to the portal"),
      id: 40,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    ACCEPT_COMPANIES: {
      description: t("Accept Company"),
      id: 41,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    REJECT_COMPANIES: {
      description: t("Reject Company"),
      id: 42,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_INFORMATION_OF_COMPANIES: {
      description: t("Edit Company information"),
      id: 43,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    ASSIGN_PROJECT_TO_REGION: {
      description: t("Assign projects to a region"),
      id: 44,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    REMOVE_PROJECT_FROM_REGION: {
      description: t("Remove projects from a region"),
      id: 45,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DELETE_REGION: {
      description: t("Delete regions"),
      id: 46,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    CREATE_REGION: {
      description: t("Create regions"),
      id: 47,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_REGION: {
      description: t("Edit regions"),
      id: 48,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_LIST_OF_REGION: {
      description: t("View regions"),
      id: 49,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    CREATE_PORTAL_ROLES: {
      description: t("Create Portal Role"),
      id: 50,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DELETE_PORTAL_ROLES: {
      description: t("Delete Portal Role"),
      id: 51,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_LIST_OF_PORTAL_ROLES: {
      description: t("View Portal Roles"),
      id: 52,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_PORTAL_ROLES: {
      description: t("Edit Portal Roles"),
      id: 53,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    STATUS_CREATE_OF_PORTAL_ENTITIES: {
      description: t("Create Status of Portal Entities"),
      id: 54,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    STATUS_DELETE_OF_PORTAL_ENTITIES: {
      description: t("Delete Status of Portal Entities"),
      id: 55,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    STATUS_EDIT: {
      description: t("Edit Status"),
      id: 56,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    STATUS_VIEW: {
      description: t("View Status"),
      id: 57,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    USERS_VIEW_ALL_IN_PORTAL: {
      description: t("View all users of Portal"),
      id: 58,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    USERS_ASSIGN_ROLE_TO_PROJECTS: {
      description: t("Assign users and their role to projects"),
      id: 59,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    USERS_REMOVE_ACCESS_TO_PROJECTS: {
      description: t("Remove which users can access which projects"),
      id: 60,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    USERS_PORTAL_ROLE_CHANGE: {
      description: t("Change portal role of any user(s)"),
      id: 61,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    USERS_PROJECT_ROLE_CHANGE: {
      description: t(
        "Change project roles of users in any projects of that portal"
      ),
      id: 62,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    ACCESS_PORTAL_SETTINGS: {
      description: t("Access Portal Settings"),
      id: 63,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    ACCESS_PROJECTS_PART_OF: {
      description: t("Access projects that they are part of"),
      id: 64,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    CHANGE_PORTAL_INFORMATION: {
      description: t("Change Portal information"),
      id: 65,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    SPECIFIC_CREATE_FORM_FLOW: {
      description: t("Create Form Flow"),
      id: 66,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    USERS_ADD_TO_VISIBILITY: {
      description: t("Add users to project mailbox visibility"),
      id: 67,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    USERS_REMOVE_FROM_VISIBILITY: {
      description: t("Remove users from project mailbox visibility"),
      id: 68,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    PROJECT_SELECT_FORM_TEMPLATES: {
      description: t("Select form templates to be used in a project"),
      id: 69,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    SPECIFIC_ACCESS_REVIEW_SETTINGS: {
      description: t("Access Review settings"),
      id: 70,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    PROJECT_ROLES_VIEW_IN_PORTAL: {
      description: t("View Project Roles in Portal"),
      id: 71,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_ORG_STRUCTURE_COMPANIES: {
      description: t("View Org Structures in Org Settings"),
      id: 72,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_ORG_STRUCTURE_COMPANIES: {
      description: t("Edit Org Structures in Org Settings"),
      id: 73,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    ADD_ORG_STRUCTURE_COMPANIES: {
      description: t("Add Org Structures in Org Settings"),
      id: 74,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DELETE_ORG_STRUCTURE_COMPANIES: {
      description: t("Delete Org Structures in Org Settings"),
      id: 75,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    MANAGE_PORTAL_SUBSCRIPTION: {
      description: t("Manage Portal Subscription Settings"),
      id: 76,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_PORTAL_SUBSCRIPTION: {
      description: t("View Portal Subscription Settings"),
      id: 77,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    TRANSMITTAL_FILE_VERSION_ORIGIN_SPACE: {
      description: t("External Tab - View file version in origin space"),
      id: 78,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    // Temporary code untill permissions code gets available in prod
    USERS_DEACTIVATE_USERS: {
      description: t("Deactivate Users"),
      id: 129,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
  };
};

export const getPermissionNames = () => {
  const permissions = getPermissions();
  const obj: any = {};

  Object.keys(permissions).forEach((key: string) => {
    obj[key] = key;
  });
  return obj;
};

const transmittalsBaseColumns = [
  "indexAtProjectLevel",
  "subject",
  "from",
  "toSpaceIds",
  "createdBy",
  "createdDate",
];

const jiraBaseColumns = [
  "key",
  "summary",
  "reported",
  "created",
  "status"
];

const defaultFormTypes = [
  "INSPECTION",
  "PROGRESS_UPDATES",
  "BILLS",
  "CHANGE_ORDER",
  "PAYMENTS",
];

export const transmittalsDefaultViews = (t?:any) => {
  if(!t){
    t = ((args:string)=>args)
  }
  return [
  {
    isShared: false,
    resourceType: "TRANSMITTALS",
    name: t("All Transmittals"),
    code: "ALL_TRANSMITTALS",
    data: {
      columns: transmittalsBaseColumns,
    },
    isDefault: true,
  },
  {
    isShared: false,
    resourceType: "TRANSMITTALS",
    name: t("Sent by me"),
    code: "SENT_BY_ME_TRANSMITTALS",
    data: {
      columns: transmittalsBaseColumns,
      filters: [
        {
          field: "createdById",
          operator: "equal",
          value: "CURRENT_USER",
        },
      ],
    },
    isDefault: true,
  }];
};

export const assetsDefaultViews = () => {
  return [
    {
      isShared: false,
      resourceType: "ASSETS",
      name: "All Assets",
      code: "ALL_Assets",
      data: {
        columns: ["_checkbox_selector", "assetId", "name", "description", "type"],
      },
      isDefault: true,
    },
    {
      isShared: false,
      resourceType: "ASSETS",
      name: "Grouped by Type",
      code: "Grouped_by_Type",
      data: {
        groupConditions: [
          {
            column: "type",
            direction: "asc",
          }
        ],
      },
      isDefault: true,
    }
  ]
}

export const jiraDefaultViews = (t?: any) => {
  if (!t) {
    t = (args: string) => args;
  }
  const statusFilter = {
    TO_DO: ["Waiting for support", "Pending", "Accepted", "Open", "Under Consideration"],
    IN_PROGRESS: ["In Progress", "Waiting for customer", "Developed", "Under investigation"],
    DONE: ["Closed", "Canceled", "Resolved", "Released", "Declined", "Already Available", "Added to Roadmap"]
  };
  
  const ALL_STATUS_OPTIONS = [
    ...statusFilter.TO_DO,
    ...statusFilter.IN_PROGRESS,
    ...statusFilter.DONE
  ];
  
  const ALL_STATUS_CATEGORY_OPTIONS = ["To Do", "In Progress", "Done"];
  
  return [
    {
      isShared: false,
      resourceType: "JIRA",
      name: t("All Tickets"),
      code: "ALL_TICKETS",
      data: {
        columns: jiraBaseColumns,
        filters: {
          createdBy: "createdByPortalUsers",
          ticketStatus: ALL_STATUS_OPTIONS,
          ticketType: "allRequests",
          ticketStatusCategory: ALL_STATUS_CATEGORY_OPTIONS,
        },
      },
      isDefault: true,
    },
    {
      isShared: false,
      resourceType: "JIRA",
      name: t("Created by me"),
      code: "CREATED_BY_ME",
      data: {
        columns: jiraBaseColumns,
        filters: {
          createdBy: "createdByMe",
          ticketStatus: ALL_STATUS_OPTIONS,
          ticketType: "allRequests",
          ticketStatusCategory: ALL_STATUS_CATEGORY_OPTIONS,
        },
      },
      isDefault: true,
    },
  ];
};

export const getFormsView = (resourceType:any, t?:any) => {
  if(!t){
    t = ((args:string)=>args)
  }
  return {
    isShared: false,
    resourceType: resourceType,
    data: {
      filterSettings: [],
      sortSettings: [],
      columnChooser: [],
    },
    name: t("Default view"),
    code: "DEFAULT_VIEW",
    isDefault: true,
  };
};

export const formsDefaultViews = (t?:any) => defaultFormTypes.map((type) => getFormsView(type, t));

export const filesDefaultViews = (t?:any) => {
  if(!t){
    t = ((args:string)=>args)
  }
  return [
    {
      isShared: false,
      resourceType: "FILES",
      name: t("All Files"),
      code: "ALL_FILES",
      data: {
        enableGrouping: false,
        enableFiltering: false,
        enableAllVersions: true,
      },
      isDefault: true,
    },
    {
      isShared: false,
      resourceType: "FILES",
      name: t("With Review Details"),
      code: "WITH_REVIEW_DETAILS",
      data: {
        showReviewColumns: true,
        enableGrouping: false,
        enableFiltering: false,
        enableAllVersions: true,
      },
      isDefault: true,
    },
    {
      isShared: false,
      resourceType: "FILES",
      name: t("Unique Files Grouped"),
      code: "UNIQUE_FILES_GROUPED",
      data: {
        group: ["fileId"],
        enableGrouping: true,
        enableFiltering: true,
        enableAllVersions: true,
      },
      isDefault: true,
    },
    {
      isShared: false,
      resourceType: "FILES",
      name: t("Unique Files Grouped with Review Details"),
      code: "UNIQUE_FILES_GROUPED_WITH_REVIEW",
      data: {
        group: ["fileId"],
        showReviewColumns: true,
        enableGrouping: true,
        enableFiltering: true,
        enableAllVersions: true,
      },
      isDefault: true,
    },
  ];
};

export const mailboxDefaultViews = (t?:any) => {
  if(!t){
    t = ((args:string)=>args)
  }
  return [
    {
      isShared: false,
      resourceType: "MAILBOX",
      name: t("All Mails"),
      code: "ALL_MAILS",
      data: {
        visibility: true,
      },
      isDefault: true,
    },
    {
      isShared: false,
      resourceType: "MAILBOX",
      name: t("Sent"),
      code: "SENT",
      data: {
        visibility: false,
      },
      isDefault: true,
    },
    {
      isShared: false,
      resourceType: "MAILBOX",
      name: t("Externally Forwarded"),
      code: "EXTERNAL",
      data: {
        visibility: false,
        disableVisibility: true,
      },
      isDefault: true,
    },
  ];
};

export const viewerDefaultViews = (t?:any) => {
  if(!t){
    t = ((args:string)=>args)
  }
  return [
    {
      isDefault: true,
      resourceType: "VIEWER",
      name: t("Default Layout"),
      code: "DEFAULT_LAYOUT",
      isShared: false,
    },
  ];
};

export const getDefaultViewDisplayName = (item: any, t: any) => {
  if (!t) t = (args: string) => args;
  if (!item?.isDefault) return item?.name;

  const defaultViewsMap: any = {
    TRANSMITTALS: () => transmittalsDefaultViews(t),
    FILES: () => filesDefaultViews(t),
    MAILBOX: () => mailboxDefaultViews(t),
    VIEWER: () => viewerDefaultViews(t),
    INSPECTION: () => formsDefaultViews(t),
    PROGRESS_UPDATES: () => formsDefaultViews(t),
    BILLS: () => formsDefaultViews(t),
    CHANGE_ORDER: () => formsDefaultViews(t),
    PAYMENTS: () => formsDefaultViews(t),
    JIRA: () => jiraDefaultViews(t),
  };

  const getViews = defaultViewsMap[item.resourceType];
  if (!getViews) return item?.name;

  const defaultViews = getViews();
  const defaultView = defaultViews.find((view: any) => view.code === item.code);
  return defaultView ? defaultView.name : item.name;
};

export const getPermissionIdDescriptionMapper = (t: any) => {
  const permissions: any = getPermissions(t);
  const obj: any = {};

  Object.keys(permissions).forEach((key) => {
    const permission = permissions[key];
    obj[permission.id] = permission.description;
  });
  return obj;
};

const setDeep = (obj: any, path: any, value: any) => {
  // sonar-disable-next-line
  const parts = path.replace(/\[(\d+)\]/g, ".$1").split(".");
  const lastIndex = parts.length - 1;
  let current = obj;

  parts.forEach((part: string, index: number) => {
    if (index === lastIndex) {
      current[part] = parseValue(value);
      return;
    }
    
    current[part] = current[part] || (isNumeric(parts[index + 1]) ? [] : {});
    current = current[part];
  });
};

const parseValue = (value: any) => {
  const stringValue = String(value);
  if (stringValue === "null") return null;
  if (stringValue === "true") return true;
  if (stringValue === "false") return false;
  if (!Number.isNaN(Number(value)) && value !== "" && typeof value === "string") {
    return Number(value);
  }
  return value;
};

const isNumeric = (str: string) => /^\d+$/.test(str);

export const convertQueryToPostPayload = (req: any) => {
  const query:any = req.query
  const result = {};
  for (const key in query) {
    setDeep(result, key, query[key]);
  }
  req.body = result;
  req.params = result;
  return result
};

export const SECTION_TYPE_REFERENCE = "SECTION_TYPE_REFERENCE";
export const SECTION_TYPE_FORM = "SECTION_TYPE_FORM";
export const SECTION_TYPE_TASK = "SECTION_TYPE_TASK";
export const SECTION_TYPE_MILESTONE = "SECTION_TYPE_MILESTONE";
export const SECTION_TYPE_QUANTITY = "SECTION_TYPE_QUANTITY";
export const SECTION_TYPE_TABLE_SECTION = "SECTION_TYPE_TABLE_SECTION";
export const SECTION_TYPE_WBS_ITEMS = "SECTION_TYPE_WBS_ITEMS";
export const SECTION_TYPE_SUMMARY_OF_CHANGES =
  "SECTION_TYPE_SUMMARY_OF_CHANGES";
export const SECTION_TYPE_REVIEWS = "SECTION_TYPE_REVIEWS";
export const SECTION_TYPE_INSPECTION = "SECTION_TYPE_INSPECTION";
export const SECTION_TYPE_PROGRESS_UPDATES = "SECTION_TYPE_PROGRESS_UPDATES";
export const SECTION_TYPE_BILLS = "SECTION_TYPE_BILLS";
export const SECTION_TYPE_CHANGE_ORDERS = "SECTION_TYPE_CHANGE_ORDERS";
export const SECTION_TYPE_BLANK_SECTION = "SECTION_TYPE_BLANK_SECTION";
export const SECTION_TYPE_PRESET_SECTION = "SECTION_TYPE_PRESET_SECTION";
export const SECTION_TYPE_SECTION_FROM_LIBRARY =
  "SECTION_TYPE_SECTION_FROM_LIBRARY";
export const SECTION_TYPE_CUSTOM_MODULES = "SECTION_TYPE_CUSTOM_MODULES";

export const debounceDelay = 300

export const formCategories = {
  inspection: "INSPECTION",
  progressUpdates: "PROGRESS_UPDATES",
  changeOrder: "CHANGE_ORDER",
  payments: "PAYMENTS",
  mailBox: "MAILBOX",
  bills: "BILLS",
  issues: "ISSUES",
  projects: "PROJECTS",
  files: "FILES",
  contract: "CONTRACT",
  model: "MODEL",
  reviews: "REVIEWS",
  transmittal: "TRANSMITTAL",
  assets: "ASSET_REGISTER",
  assetsProject: "ASSET_REGISTER_PROJECT",
  drawing: "DRAWING"
};

export const presetSectionsCodeObject:any = {
  SECTION_TYPE_QUANTITY,
  SECTION_TYPE_REFERENCE,
  SECTION_TYPE_FORM,
  SECTION_TYPE_TASK,
  SECTION_TYPE_MILESTONE,
  SECTION_TYPE_TABLE_SECTION,
  SECTION_TYPE_WBS_ITEMS,
  SECTION_TYPE_SUMMARY_OF_CHANGES,
  SECTION_TYPE_REVIEWS,
  SECTION_TYPE_INSPECTION,
  SECTION_TYPE_PROGRESS_UPDATES,
  SECTION_TYPE_BILLS,
  SECTION_TYPE_CHANGE_ORDERS,
};

export const libraryEntities = {
  FORM_FLOW: "FORM_FLOW",
  TEMPLATE_SECTION: "TEMPLATE_SECTION",
};
export const getProjectMailThreadsPageUrl = (
  projectId: string,
  mailId: string
) => `/project/${projectId}/mails/${mailId}/mailThread?projectId=${projectId}`;

export function getDistanceInMeters({ pos1, pos2 }: any) {
  if (!pos1 || !pos2) {
    return 0;
  }
  const toRad = (deg: any) => (deg * Math.PI) / 180;

  const R = 6371000; // Radius of Earth in meters
  const lat1 = toRad(pos1.lat);
  const lat2 = toRad(pos2.lat);
  const deltaLat = toRad(pos2.lat - pos1.lat);
  const deltaLng = toRad(pos2.lng - pos1.lng);

  const a =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(lat1) *
      Math.cos(lat2) *
      Math.sin(deltaLng / 2) *
      Math.sin(deltaLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
}
export const recordStatus = {
  ACTIVE: 0,
  ARCHIVED: 1,
  DELETED: 2,
} as const;

export const projectSpaceActiveStatusCheck = {
  "project.recordStatus": recordStatus.ACTIVE,
  "space.recordStatus": recordStatus.ACTIVE,
} as const;

export const clashVisibilityOptions: any = {
  XRAY_MODE: "XRAY_MODE",
  HIDE_NON_CLASHING: "HIDE_NON_CLASHING",
  SHOWALL: "SHOWALL",
};

export const cubeParams = [
  "CUBE Name",
  "CUBE Volume",
  "CUBE Area",
  "Quantity",
  "Unit",
];

export const getZohoBackendUrl = () => process.env.REACT_APP_ZOHO_BACKEND_URL;

export const streamingModeMap = {
  All: "All",
  Interactive: "Interactive",
  OnDemand: "On Demand",
};

export const selectionSetSupportedExtension = [
  "rvt",
  "nwd",
  "ifc",
  "ifczip",
  "rfa",
  "dwg",
  "fbx",
];

export const objectTreeSupportedExtension = [
  "rvt",
  "nwd",
  "ifc",
  "ifczip",
  "rfa",
];

export const RC_MENU_ITEMS = {
  ISOLATE: "Isolate",
  FOCUS: "Focus", 
  HIDE: "Hide",
  ON_DEMAND_LOAD: "onDemandLoad",
  OVERRIDE: "Override",
  TRANSFORM: "Transform",
  SCALE: "Scale",
  COLOR: "Color",
  SET_COLOR: "Set Color",
  MODIFY_COLOR: "Modify Color",
  TRANSPARENCY: "Transparency",
  SELECTION: "Selection",
  RESET: "Reset",
  FILE: "File",
  ELEMENT:"Element",
  SHOW_ALL: "Show All",
  PROPERTIES: "Properties",
  PARENT:"Parent",
  GRAND_PARENT:"Grand Parent"
};
export const preExistingModules = [
  'Inspections',
  'Bills',
  'Progress Updates',
  'General Forms',
  'Permit To Work',
  'Change Orders',
  'Estimates',
  'Schedules',
  'Files',
  'Transmittals',
  'Tasks',
  'Spaces',
  'Reviews',
  'Issues',
  'Mailbox',
  'Clash',
  'Contracts',
  'Risk Management',
  'Payments',
  'Tenders',
  'Asset Register',
  'Procurement',
  'Projects',
  'Model',
];
export const PROJECT = "project"
export const DEFAULT_CALENDAR_NAME ="Default CUBE Calendar"
export const PROJECT_CALENDAR ="PROJECTCALENDAR"

export const PORTAL_FULL_SEAT = 1;
export const PORTAL_NO_SEAT = 0;
export const PORTAL_HALF_SEAT = 2;

export const CDEModulesEnabled = ["Spaces", "Tasks", "Transmittals", "Issues", "Reviews", "Meetings"]
export const PMModulesEnabled = [
"Files",
"Mailbox",
"Estimates",
"Schedules",
"Progress Updates",
"Bills",
"Change Orders",
"Inspections",
"Contracts"
]

export const CLASH_ADDON_CODE = "CD"
export const CUSTOM_MODULE_ADDON_CODE = "CM"
export const BIM_TAKEOFF_ADDON_CODE = "BT"
export const RATE_ANALYSIS_ADDON_CODE = "RA"
export const SIMULATION_ADDON_CODE = "4D5D"

export const ADDONS_DISPLAY_NAME = {
  [CLASH_ADDON_CODE]: "Clash Tests",
  [CUSTOM_MODULE_ADDON_CODE]: "Custom Modules",
  [BIM_TAKEOFF_ADDON_CODE]: "BIM Takeoff",
  [RATE_ANALYSIS_ADDON_CODE]: "Rate Analysis",
  [SIMULATION_ADDON_CODE]: "Simulation",
} as const;

export type AddonsDisplayNameType = keyof typeof ADDONS_DISPLAY_NAME;

export const MATERIAL = "material"
export const P6TYPE = "primaveraP6-parse"

export const getIsAddonAccess = (addonCode : string, portalData : any)=>{
  const addons = _.get(portalData, "subscription.addons");
  return  addons == undefined || addons.some((addon: any) => addon.addon_code.includes(addonCode))
}

export const fileConversionStatus = {
  NOT_STARTED: "NOT_STARTED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  ERROR: "ERROR",
};

export const exportType = {
  PDF: "pdf",
  EXCEL: "excel",
};

export const DOCUMENT_TYPE = {
  DOCUMENT_TYPE_MODEL_PROPERTIES: "MODEL_PROPERTIES",
  DOCUMENT_TYPE_DRAWING_PROPERTIES: "DRAWING_PROPERTIES",
  DOCUMENT_TYPE_CUSTOM_PROPERTIES: "CUSTOM_PROPERTIES",
  DOCUMENT_TYPE_QUANTITY: "QUANTITY",
  DOCUMENT_TYPE_ASSETDATA: "ASSETDATA",
};
